import { Box } from "@prismicio/editor-ui"

import { BlankSlate } from "./BlankSlate"
import { SelectedVersion } from "./SelectedVersion"
import type { UseRefineSliceResult } from "./useRefineSlice"

type Props = UseRefineSliceResult

export function RefineSlice(props: Props) {
  const {
    prompt,
    setPrompt,
    refine,
    status,
    disabled,
    simulatorUrl,
    selectedVersion,
  } = props

  if (!simulatorUrl) return <MissingSimulator />

  const slice = selectedVersion?.slice
  if (!slice) return null

  return (
    <SelectedVersion
      prompt={prompt}
      setPrompt={setPrompt}
      slice={slice}
      status={status}
      disabled={disabled}
      refine={refine}
    />
  )
}

function MissingSimulator() {
  return (
    <Box flexDirection="column" flexGrow={1} justifyContent="center">
      <BlankSlate type="simulatorMissing" />
    </Box>
  )
}
